import { Box, Link } from '@mui/material'
import { navigate } from '@reach/router'
import { useTranslation } from 'react-i18next'

import * as routes from 'src/constants/routes'

import { SpanCopyright, SpanSeparator, footerStyles as styles } from './FooterStyles'

function Separator(): JSX.Element {
  return <SpanSeparator>·</SpanSeparator>
}

export default function Footer(): JSX.Element {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <Box sx={styles.footer}>
      <Box sx={styles.footerContent}>
        <Box sx={styles.rowIcons}>
          <Box flex="1 1 auto" display="flex" alignItems="center">
            <img
              src="https://assets.lefebvre.es/media/logos-2/png/lefebvre-205x56.png"
              alt="Lefebvre"
              width={149}
              height={40}
            />
          </Box>

          <Box sx={styles.rowWrapperIcons} flex="0 0 auto" display="flex" alignItems="center">
            <Link href="https://www.instagram.com/lefebvre_es" sx={styles.linkIcon} target="_blank">
              <img
                src="https://assets.lefebvre.es/media/icons-2/svg/icon-rrss-instagram-square.svg"
                width={32}
                height={32}
              />
            </Link>

            <Link
              href="https://www.facebook.com/Lefebvre.ES/"
              sx={styles.linkIcon}
              target="_blank"
            >
              <img
                src="https://assets.lefebvre.es/media/icons-2/svg/icon-rrss-facebook-square.svg"
                width={32}
                height={32}
              />
            </Link>

            <Link
              href="https://www.linkedin.com/company/lefebvre_es"
              sx={styles.linkIcon}
              underline="hover"
              target="_blank"
            >
              <img
                src="https://assets.lefebvre.es/media/icons-2/svg/icon-rrss-linkedin-square.svg"
                width={32}
                height={32}
              />
            </Link>

            <Link href="https://twitter.com/Lefebvre_ES" sx={styles.linkIcon} target="_blank">
              <img
                src="https://assets.lefebvre.es/media/icons-2/svg/icon-rrss-x-square.svg"
                width={32}
                height={32}
              />
            </Link>

            <Link
              href="https://www.youtube.com/channel/UCAxbOiNpUotcbZIRL3IxEDg"
              sx={styles.linkIcon}
              target="_blank"
            >
              <img
                src="https://assets.lefebvre.es/media/icons-2/svg/icon-rrss-youtube-square.svg"
                width={32}
                height={32}
              />
            </Link>
          </Box>
        </Box>
        <Box sx={styles.rowLinks} display="flex" alignItems="center">
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <SpanCopyright>{t('components.footer.copyright', { year: currentYear })}</SpanCopyright>
            <Link
              href="https://lefebvre.es/aviso-legal/"
              sx={styles.link}
              underline="none"
              target="_blank"
            >
              {t('components.footer.legal')}
            </Link>
            <Separator />
            <Link
              href="https://lefebvre.es/politica-privacidad"
              sx={styles.link}
              underline="none"
              target="_blank"
            >
              {t('components.footer.privacyPolicy')}
            </Link>
            <Separator />
            <Link
              href="https://lefebvre.es/politica-de-cookies/"
              sx={styles.link}
              underline="none"
              onClick={(ev: any) => {
                ev.preventDefault()
                navigate(routes.COOKIE_POLICY)
              }}
            >
              {t('components.footer.cookies')}
            </Link>
          </Box>
        </Box>
      </Box>
      <Box sx={styles.footerBorder} />
    </Box>
  )
}
